import { storeToRefs } from 'pinia';

import { pipedriveStore } from '@/modules/pipedriveStore';

export function usePipedriveStore() {
  const store = pipedriveStore();
  const data = storeToRefs(store);

  function loadRealEstateOrderSummary(payload) {
    return store.loadRealEstateOrderSummary(payload);
  }

  return {
    data,
    loadRealEstateOrderSummary
  };

}